"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createCombinationWordAllow = exports.createAllow = void 0;
var DictionaryAllow_1 = require("./DictionaryAllow");
exports.createAllow = function (value) {
    return new DictionaryAllow_1.DictionaryAllow({
        value: value
    });
};
exports.createCombinationWordAllow = function () {
    return new DictionaryAllow_1.DictionaryAllow({
        value: "{{COMBINATION_WORD}}"
    });
};
//# sourceMappingURL=DictionaryAllowFactory.js.map


//////////////////
// WEBPACK FOOTER
// ../domain/lib/Dictionary/DictionaryAllowFactory.js
// module id = 977
// module chunks = 0